import StackedBarChart from "../../../../../src/core/StackedBarChart";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  StackedBarChart,
  Playground,
  React
};